import Denied from './Denied';

const DeniedRoute = {
  path: '/denied',
  element: <Denied />,
};

export default DeniedRoute;
